import { render } from "./PbxHeader.vue?vue&type=template&id=3b61c74c&scoped=true"
import script from "./PbxHeader.vue?vue&type=script&lang=js"
export * from "./PbxHeader.vue?vue&type=script&lang=js"

import "./PbxHeader.vue?vue&type=style&index=0&id=3b61c74c&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b61c74c"]])

export default __exports__